/* global $ */
/* global Utils */
/* global gettext */

(function (scope) {
  "use strict";

  var PrintSettingsView = (scope.PrintSettingsView = function (
    controller,
    design,
    materials,
    texts
  ) {
    this.controller = controller;
    this.design = design;
    this.materials = materials;
    this.texts = texts;
    this.$el = $(".PrintSettingsView");

    this.$settingScale = $(".setting-scale", this.$el);

    this.$el.on("click", this.clickOnSettingsDisabled.bind(this));
    this.$el.on(
      "change",
      ".setting-process select",
      this.materialChanged.bind(this)
    );
    this.$el.on("click", "[data-action=top]", this.scrollTop.bind(this));
    this.$el.on("click", "[data-action=reset]", this.resetClicked.bind(this));
    this.$el.on(
      "click",
      "[data-action=finalproof]",
      this.finalproofClicked.bind(this)
    );

    scope.PrintScaleDecorator.call(this);

    this.updateScale();
    this.updateSelectors();

    this.$el.on("select2:open", this.select2Opened.bind(this));
    this.$el.on("select2:close", this.select2Closed.bind(this));
    this.$el.on("change.select2", this.select2Closed.bind(this));
    this.$el.on(
      "select2:select",
      this.triggerGoogleTagManagerSelect2Settings.bind(this)
    );
  });

  // Let's decorate a bit. Scale methods are common with the multi print page, so they've been moved to another file.
  PrintSettingsView.prototype = $.extend(
    PrintSettingsView.prototype,
    scope.PrintScaleDecorator.prototype
  );

  /**
   * Toggle "usability" of the view by adding a gray layer upon it.
   * @param {bool} enabled
   */
  PrintSettingsView.prototype.enabled = function (enabled) {
    this.$el.toggleClass("disabled", !enabled);
  };

  /**
   * Called when clicking on printSettingsView when it's disabled
   */
  PrintSettingsView.prototype.clickOnSettingsDisabled = function (e) {
    if (
      this.controller.controllerType != "2D" &&
      this.$el.hasClass("disabled") &&
      this.controller.currentTool != sculpteo.PrintToolsView.TOOLS.DASHBOARD
    ) {
      this.controller.notify("info", sculpteo.INFO.TOOL_SETTINGS, true);
    }
  };

  /**
   * Update displayed scale based on design's size and user's scale.
   * @public
   */
  PrintSettingsView.prototype.updateScale = function (scale) {
    scale = scale || this.design.size.userScale;

    $("[name=x]", this.$el).val(
      Utils.decimalPrecision(this.design, this.design.size.x * scale)
    );
    $("[name=y]", this.$el).val(
      Utils.decimalPrecision(this.design, this.design.size.y * scale)
    );
    $("[name=z]", this.$el).val(
      Utils.decimalPrecision(this.design, this.design.size.z * scale)
    );
    $("[name=scale]", this.$el).val(parseFloat(scale * 100).toFixed(1));
    $("[type=range]", this.$el)
      .val(this.logsl.position(+scale * 100))
      .trigger("update"); // Custom event when updating field by .val()
  };

  /**
   * Update displayed unit based on provided unit or default one
   * @public
   */
  PrintSettingsView.prototype.updateScaleError = function () {
    this.$settingScale.removeClass("setting-error");
    if (
      this.controller.checkError(sculpteo.ERROR.SCALE_MAX) ||
      this.controller.checkError(sculpteo.ERROR.SCALE_MIN) ||
      this.controller.checkError(sculpteo.ERROR.SOLIDITY_WILL_BREAK)
    ) {
      this.$settingScale.addClass("setting-error");
      this.$settingScale.hide().show(0);
    }
  };

  /**
   * Update displayed unit based on provided unit or default one
   * @public
   */
  PrintSettingsView.prototype.updateUnit = function (unit) {
    unit = unit || this.design.size.unit || this.design.designerUnit;
    $("[name=setting-scale-units-name][value=" + unit + "]").attr(
      "checked",
      true
    );
  };

  /**
   * Callback on unit field change
   * @private
   * @param {object} event
   */
  PrintSettingsView.prototype.materialChanged = function (
    event,
    selectorIndex
  ) {
    var selected = this.controller.materials.getMapFromSelectors(
      this.$el,
      event ? $(event.currentTarget) : null,
      selectorIndex
    );
    this.controller.updateMaterial(
      selected.material,
      selected.finish,
      selected.painting,
      "print_new_sidebar",
      selected.options,
      selected.color
    );
  };

  /**
   * Update displayed selectors
   * @private
   * @see PrintMaterialCollection.getSelectors()
   * @see PrintMaterialCollection.getMapIndex()
   * @see PrintMaterialCollection.getMapValue()
   */
  PrintSettingsView.prototype.updateSelectors = function () {
    var $container = $(".setting-process", this.$el);
    $container.empty();

    this.materials.generateSelectors($container, this.design, this.texts);
  };

  /**
   * Back to the future top.
   * @public
   * @param {object} event
   */
  PrintSettingsView.prototype.scrollTop = function (event) {
    if (event) {
      event.preventDefault();
    }

    if ($(window).width() < 768) {
      $("html, body").animate({ scrollTop: 450 }, 300);
    } else {
      $("html, body").animate({ scrollTop: 0 }, 300);
    }
  };

  /**
   * Reset configuration
   * @private
   * @param {object} event
   */
  PrintSettingsView.prototype.resetClicked = function (event) {
    event.preventDefault();
    this.controller.reset();
  };

  /**
   * Request final proof
   * @private
   * @param {object} event
   */
  PrintSettingsView.prototype.finalproofClicked = function (event) {
    event.preventDefault();
    this.controller.requestFinalProof($(event.currentTarget).data("email"));
  };

  /**
   * Toggle final proof button
   * @public
   * @param {bool} active
   */
  PrintSettingsView.prototype.toggleFinalProof = function (active) {
    $("[data-action=finalproof]", this.$el).attr("disabled", !active);
  };

  /**
   * We need to add a class to the setting process when a dropdown is open to be able to reduce the opacity
   * of the other dropdown. It's helpful to better identificate the dropdown in the middle of all of them.
   * + we hide the scroll on the body when a selector is open
   */
  // local var
  var previous_opened_selector;
  PrintSettingsView.prototype.select2Opened = function (evt) {
    var $container = $(".setting-process", this.$el);
    $container.addClass("dropdown-open");
    $(evt.currentTarget).prev().addClass("dropdown-open-title");

    previous_opened_selector = evt.currentTarget;
    var scroll_w = printUtilsFunctions.getBrowserScrollSize().width;

    $("body").css("margin-right", scroll_w + "px");
    $("body").addClass("no-scroll");
  };

  PrintSettingsView.prototype.select2Closed = function (evt) {
    var $container = $(".setting-process", this.$el);
    $container.removeClass("dropdown-open");
    $(evt.currentTarget).prev().removeClass("dropdown-open-title");
    $("body").removeClass("no-scroll");

    if (previous_opened_selector == evt.currentTarget) {
      $("body").removeClass("no-scroll");
      $("body").css("margin-right", 0);
    }
  };

  PrintSettingsView.prototype.triggerGoogleTagManagerSelect2Settings =
    function (e) {
      // data from select2
      // data.id -> select.option.value
      var data = e.params.data;

      // the name of the category that we are currently changing
      var selectorType = $(data.element).attr("data-selector-type");

      // data.id is the value of the selector
      // ex: nylon_pa12_60u    for a material
      if (window.GoogleTagManager) {
        // send tag to TGM
        window.GoogleTagManager.sendTag({
          category: "print",
          action: "print.sidebar." + selectorType,
          label: data.id,
        });
      }
    };
})((window.sculpteo = window.sculpteo || {}));
